// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.13.2@vant/lib/style/base.css
// module id = BlTd
// module chunks = 71